import React from "react";
import { useTranslation } from "react-i18next";

// Reusable search input with a Clear button.
const SearchBox = ({ value, onChange, placeholder, className = "" }) => {
  const { t } = useTranslation();
  const label = placeholder || t("common.searchPlaceholder", "Search...");
  return (
    <div className={`input-group ${className}`}>
      <span className="input-group-text" aria-hidden="true">🔍</span>
      <input
        type="search"
        className="form-control"
        placeholder={label}
        aria-label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {value && (
        <button type="button" className="btn btn-outline-secondary" onClick={() => onChange("")}>
          {t("common.clear", "Clear")}
        </button>
      )}
    </div>
  );
};

export default SearchBox;
